import { render, staticRenderFns } from "./component-ce7dba28.vue?vue&type=template&id=38e97586&scoped=true&"
import script from "./component-ce7dba28.vue?vue&type=script&lang=js&"
export * from "./component-ce7dba28.vue?vue&type=script&lang=js&"
import style0 from "./component-ce7dba28.vue?vue&type=style&index=0&id=38e97586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e97586",
  null
  
)

export default component.exports